import type { SupplyApp, SupplyDomain } from '../../../campaigns/supply/model';
import type { TailoredSupplyItem } from '../../../supply/tailored-supply/model';
export function moveSelectionOnInclusionToggle<TItem>({
  excludedItems,
  included,
  includedItems,
}: {
  excludedItems: TItem[];
  included: boolean;
  includedItems: TItem[];
}) {
  if (included) {
    if (!includedItems.length && excludedItems.length) {
      return { includedItems: excludedItems, excludedItems: [] };
    }
    return { includedItems, excludedItems };
  }

  if (!excludedItems.length && includedItems.length) {
    return { includedItems: [], excludedItems: includedItems };
  }
  return { includedItems, excludedItems };
}

export function toSupplyApps(items: unknown[]): SupplyApp[] {
  return items.filter(hasId).map((item) => ({
    status: undefined,
    appStoreId: undefined,
    appStoreUrl: undefined,
    bundleId: undefined,
    domain: undefined,
    platform: undefined,
    iabCategories: [],
    createdOn: undefined,
    id: item.id,
    name: typeof item.name === 'string' ? item.name : item.id,
  }));
}

export function toSupplyDomains(items: unknown[]): SupplyDomain[] {
  return items.filter(hasId).map((item) => {
    let url = item.id;
    if (typeof item.url === 'string') {
      url = item.url;
    } else if (typeof item.domain === 'string') {
      url = item.domain;
    }

    return {
      id: item.id,
      url,
      iabCategories: [],
    };
  });
}

export function toTailoredSupplies(items: unknown[]): TailoredSupplyItem[] {
  return items.filter(hasId).map((item) => ({
    ...item,
    appsCount: typeof item.appsCount === 'number' ? item.appsCount : 0,
    domainsCount: typeof item.domainsCount === 'number' ? item.domainsCount : 0,
    publishers: Array.isArray(item.publishers) ? item.publishers : [],
    appPlatforms: Array.isArray(item.appPlatforms) ? item.appPlatforms : [],
    appIabCategories: Array.isArray(item.appIabCategories) ? item.appIabCategories : [],
    appLanguages: Array.isArray(item.appLanguages) ? item.appLanguages : [],
    description: typeof item.description === 'string' ? item.description : undefined,
    name: typeof item.name === 'string' ? item.name : item.id,
  }));
}

function hasId(item: unknown): item is Record<string, unknown> & { id: string } {
  return Boolean(
    item && typeof item === 'object' && typeof (item as Record<string, unknown>)['id'] === 'string',
  );
}
